import { createContext, useReducer, useContext } from "react";

const initialState = {
  selectedByPeriod: true,
  hoursPerDay: 7,
  selectedStartDay: null,
  selectedEndDay: null,
  hoveredPeriodId: null,
  categoryTotals: {
    FORMATION: { days: 0, hours: 0, visible: true },
    ENTREPRISE: { days: 0, hours: 0, visible: true },
    VACANCES: { days: 0, hours: 0, visible: true },
    FERIES: { days: 0, hours: 0, visible: true },
  },
};

const calendarReducer = (state, action) => {
  switch (action.type) {
    case "TOGGLE_PERIOD_SELECTION":
      return {
        ...state,
        selectedByPeriod: !state.selectedByPeriod,
      };
    case "SET_HOURS_PER_DAY":
      return {
        ...state,
        hoursPerDay: action.payload,
      };
    case "SELECT_START_DAY":
      return {
        ...state,
        selectedStartDay: action.payload,
      };
    case "SELECT_END_DAY":
      return {
        ...state,
        selectedEndDay: action.payload,
      };
    case "RESET_SELECTION":
      return {
        ...state,
        selectedStartDay: null,
        selectedEndDay: null,
      };
    case "SET_CATEGORIES_TOTALS":
      return {
        ...state,
        categoryTotals: action.payload,
      };
    case "SET_HOVERED_PERIOD_ID":
      return {
        ...state,
        hoveredPeriodId: action.payload,
      };
    case "SET_CATEGORY_TOTALS":
      return {
        ...state,
        [action.payload.category]: action.payload.data,
      };
    case "TOGGLE_CATEGORY_VISIBILITY":
      return {
        ...state,
        categoryTotals: {
          ...state.categoryTotals,
          [action.payload]: {
            ...state.categoryTotals[action.payload],
            visible: !state.categoryTotals[action.payload].visible,
          },
        },
      };
    default:
      return state;
  }
};

const CalendarContext = createContext();

// 4️⃣ Provider
export const CalendarProvider = ({ children }) => {
  const [state, dispatch] = useReducer(calendarReducer, initialState);

  return (
    <CalendarContext.Provider value={{ state, dispatch }}>
      {children}
    </CalendarContext.Provider>
  );
};

export const useCalendar = () => useContext(CalendarContext);
